import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { singletonHook } from "react-singleton-hook";
import { DomainConfigContext } from "react-builder";
import { Video } from "../types/vod-types";
import { useProductApi } from "../custom-hooks/useProductApi";

interface FitnessVideoCategory {
  category: string;
  videos: Video[];
}

interface OutPut {
  videos: Video[];
  addVideo: (v: Video) => void;
  videosBySubCategory: FitnessVideoCategory[];
  loadVideos: (category: string) => Promise<Video[]>;
  loadSecureFile: (url: string) => Promise<string | undefined>;
}

export const useFitness = singletonHook<OutPut>({} as any, function (): OutPut {
  const [videos, setVideos] = useState<Video[]>([]);
  const [videosBySubCategory, setVideosBySubCategory] = useState<FitnessVideoCategory[]>([]);
  const [videoPromise, setVideoPromise] = useState<Promise<Video[]>>();
  const API = useProductApi<Video>();
  const secureFileApi = useProductApi<{ link: string; expiry: number }>();

  const addVideo = function (video: Video) {
    setVideos([...videos, video]);
  };
  const loadVideos = useMemo(
    () =>
      (category: string): Promise<Video[]> => {
        if (!API) return Promise.resolve([]);

        // in progress
        if (videoPromise) return videoPromise;

        const options = {
          query: JSON.stringify({ category }),
          populate: "preview",
        };
        const p = API.list("fitness/FitnessVideo", options)
          .then((result) => {
            setVideos(result.list);
            return result.list;
          })
          .catch((error) => {
            return [] as Video[];
          })
          .finally(() => {
            setVideoPromise(undefined);
          });
        setVideoPromise(p);
        return p;
      },
    [API]
  );
  const loadSecureFile = async (url: string) => {
    if (!secureFileApi) return;
    try {
      const response = await secureFileApi.single(`File/${url}/secure`);
      console.log("response.link", response.link);

      return response.link;
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };
  useEffect(() => {
    const map: { [key: string]: Video[] } = videos.reduce((map: any, item) => {
      if (item.subCategory) {
        map[item.subCategory!] = map[item.subCategory!] || [];
        map[item.subCategory!].push(item);
      }
      return map;
    }, {});
    const sortedCategories = Object.keys(map)
      .sort()
      .map((key) => ({ category: key, videos: map[key] }));

    setVideosBySubCategory(sortedCategories);
    console.log("VideosBySubCategory", sortedCategories);
  }, [videos]);

  return { videos, addVideo, loadVideos, videosBySubCategory, loadSecureFile };
});
